export default {
  title: 'Contactos',

  copyTo: 'Copiar',

  titles: {
    custom: {
      fields: 'Campos personalizados'
    }
  },

  labels: {
    list: 'Lista',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    firstName: 'Nombre',
    lastName: 'Apellido',
    middleName: 'Segundo nombre',
    date: 'Fecha de nacimiento',
    gender: 'Género',
    contactList: 'Lista de contactos',
    actions: '',
    custom: 'Campo personalizado',
    custom01: 'Personalizado 01',
    custom02: 'Personalizado 02',
    custom03: 'Personalizado 03',
    custom04: 'Personalizado 04',
    custom05: 'Personalizado 05',
    custom06: 'Personalizado 06',
    custom07: 'Personalizado 07',
    custom08: 'Personalizado 08',
    custom09: 'Personalizado 09',
    custom10: 'Personalizado 10',
    custom11: 'Personalizado 11',
    custom12: 'Personalizado 12',
    custom13: 'Personalizado 13',
    custom14: 'Personalizado 14',
    custom15: 'Personalizado 15',
    custom16: 'Personalizado 16',
    custom17: 'Personalizado 17',
    custom18: 'Personalizado 18',
    custom19: 'Personalizado 19',
    custom20: 'Personalizado 20',
    clear: 'Limpiar filtro',
    name: 'Nombre'
  },

  dialogs: {
    titles: {
      create: 'Crear contacto',
      update: 'Actualizar contacto',
      remove: 'Eliminar contacto',
      import: 'Importar contactos'
    }
  },

  subheaders: {
    custom: 'Campos personalizados',
    date: 'Seleccionar fecha de nacimiento'
  },

  emptyState: {
    emptyAddressBook: 'No se encontró ninguna libreta de direcciones',
    title: 'No hay contactos',
    description: '{0} un archivo csv/xls/xlsx o {1} un contacto'
  },

  contents: {
    confirm: {
      remove: '¿Está seguro de que desea eliminar el contacto?'
    },
    import: {
      loading: 'El diálogo se cerrará automáticamente al completar la importación.',
      success: 'Se importó correctamente: {count}.',
      error: 'Lamentablemente, no pudimos importar ni un solo número del archivo cargado.<br><ul><li>Compruebe que los nombres de las columnas del archivo sean correctos. Intente renombrar la columna con el número de teléfono a "phone".</li><li>Si no puede cargar un archivo CSV, pruebe con XLSX o XLS. En este caso, los registros deben estar en la primera hoja / libro.</li><li>Póngase en contacto con el soporte para obtener ayuda. Puede que necesitemos su archivo para investigar el problema.</li></ul>'
    }
  },

  buttons: {
    add: 'Agregar',
    remove: 'Eliminar'
  },

  tooltips: {
    add: 'Agregar un contacto a la lista de contactos',
    remove: 'Eliminar un contacto de la lista de contactos',
    loading: 'Cargando...',
    total: '&#xb7 &#xb7 &#xb7 \ntotal {total}',
    noData: 'Sin contactos',
    permanent: 'Inserte la palabra "permanente" en este campo'
  },

  errors: {
    phone: 'Formato de número de teléfono no válido',
    email: 'Formato de correo electrónico no válido',
    phoneOrEmail: 'Ingrese un número de teléfono o correo electrónico',
    fio: 'Solo se permiten letras, espacios, guion y apóstrofo'
  },

  snackbars: {
    created: 'Contacto creado con éxito.',
    updated: 'Contacto actualizado con éxito.',
    removed: 'Contacto eliminado con éxito.'
  }
}
